/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface OneDSubstanceConcentration
 */
export interface OneDSubstanceConcentration {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  substance: string;
  /**
   *
   */
  readonly substanceId?: number;
  /**
   *
   */
  readonly substanceName?: string;
  /**
   *
   */
  initialConcentration: string;
  /**
   *
   */
  readonly initialConcentrationId?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the OneDSubstanceConcentration interface.
 */
export function instanceOfOneDSubstanceConcentration(
  value: object
): value is OneDSubstanceConcentration {
  if (!("substance" in value) || value["substance"] === undefined) return false;
  if (
    (!("initialConcentration" in (value as Record<string, any>)) &&
      !("initial_concentration" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["initialConcentration"] === undefined &&
      (value as Record<string, any>)["initial_concentration"] === undefined)
  )
    return false;
  return true;
}

export function OneDSubstanceConcentrationFromJSON(json: any): OneDSubstanceConcentration {
  return OneDSubstanceConcentrationFromJSONTyped(json, false);
}

export function OneDSubstanceConcentrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OneDSubstanceConcentration {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    substance: json["substance"],
    substanceId: json["substance_id"] == null ? undefined : json["substance_id"],
    substanceName: json["substance_name"] == null ? undefined : json["substance_name"],
    initialConcentration: json["initial_concentration"],
    initialConcentrationId:
      json["initial_concentration_id"] == null ? undefined : json["initial_concentration_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function OneDSubstanceConcentrationToJSON(json: any): OneDSubstanceConcentration {
  return OneDSubstanceConcentrationToJSONTyped(json, false);
}

export function OneDSubstanceConcentrationToJSONTyped(
  value?: Omit<
    OneDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    substance: value["substance"],
    initial_concentration: value["initialConcentration"],
  };
}
